<template>
  <div>
    <v-simple-table dense>
      <thead>
        <tr>
          <th>Description</th>
          <th class='text-right'>Rating</th>
          <th class='text-center'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <span v-on='on'>TOS</span>
              </template>
              <span>
                Time on site (mins)
              </span>
            </v-tooltip>
          </th>
          <th class='text-right'>Base Price</th>
        </tr>
      </thead>
      <tbody v-if='ratings.length'>
        <tr v-for='r in ratings' :key='r.id' :class="r.id === selected ? 'info--text' : ''">
          <td>{{ r.description }}</td>
          <td class='text-right'>{{ r.rating | dec}}</td>
          <td class='text-center'>{{ r.time_on_site }}</td>
          <td class='text-right'>{{ r.base_price | decMoney }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr class='info--text' v-if='selected_obj'>
          <td>{{ selected_obj.description }}</td>
          <td class='text-right'>{{ selected_obj.rating | dec}}</td>
          <td class='text-center'>{{ selected_obj.time_on_site }}</td>
          <td class='text-right'>{{ selected_obj.base_price | decMoney }}</td>
        </tr>
        <tr v-else><td colspan='4' class='caption grey--text text--lighten-1'>No rating found</td></tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'ratings-chart',
  props: {
    selected: {
      required: false,
      default: null
    },
    selected_obj: {
      required: false
    },
    ratings: {
      required: false,
      type: Array,
      default: () => []
    }
  }
}
</script>
